import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { AxiosError } from "axios";

type CategoryProps = {
    id: number,
    name: string
}

async function update(data: CategoryProps): Promise<void> {
    try {
        await ApiClient({ url: `categories/${data.id}`, method: "PUT", data: { name: data.name } });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePutCategoryMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, CategoryProps>({
        mutationKey: ["put-category"],
        mutationFn: update,
        onSuccess,
        onError
    });
}